import getIdReduxUtil from 'modules/redux/utils/get-id'
import { toSlugStringUtil } from 'packages/src'
import getNameReduxUtil from 'modules/redux/utils/get-name'

/**
 * Generates the pathname for a workout that belongs to a plan.
 * Uses the new plan workout route format: /plans/:planId/:planSlug/workouts/:workoutId/:workoutSlug
 *
 * @param {Object} params
 * @param {Object} params.workout - The workout instance
 * @param {Object} params.plan - The plan instance
 * @returns {string} The pathname for the plan workout
 */
export default function getPlanWorkoutPathnameUtil ({ workout, plan }) {
  const workoutName = getNameReduxUtil(workout)
  const workoutId = getIdReduxUtil(workout)
  const workoutSlug = toSlugStringUtil(workoutName)

  const planName = getNameReduxUtil(plan)
  const planId = getIdReduxUtil(plan)
  const planSlug = toSlugStringUtil(planName)

  return `/plans/${planId}/${planSlug}/workouts/${workoutId}/${workoutSlug}`
}
